import React, { useState, useEffect } from "react";
import { Button, Icon, Block, BlockHeadContent } from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import LogoDark from "../../../images/logo.png";
import { invoiceData } from "./Invoice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";
import { RUPEES_SYMBOL } from "../../../assets/constants";
import { getOrdersDetailsAPI } from "../../../api/pahrmacy";

const InvoicePrint = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState();
  const location = useLocation();
  let { invoiceId } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("order-id");
  const userId = queryParams.get("user-id");
  console.log("loc", location);

  const logout = useLogout();
  useEffect(() => {
    setTimeout(() => {
      window.print();
    }, 1000);
  }, []);

  useEffect(() => {
    orderDetails();
  }, []);

  const orderDetails = () => {
    const body = {
      orderId: orderId,
      userId: userId == "null" ? "" : userId,
    };
    setIsLoading(true);
    getOrdersDetailsAPI(body)
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();

          logout();
        } else if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();

          setData(res.data.data);
          setIsLoading(false);
        } else if (res.data.status === false) {
          setIsLoading(false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };
  console.log(data, "data");
  // const onOrderClick = (item) => {
  //   const body = {
  //     orderId: data?.order?.id || "",
  //     userId: data?.order?.userId || "",
  //   };
  //   navigate("/order-details", { state: body });
  // };

  return (
    <body className="bg-white">
      <Head title="Invoice Print"></Head>
      {/* <div className="text-end me-5 mt-5">
        <Button color="primary" outline onClick={() => onOrderClick()}>
          <Icon name="arrow-left" />
        </Button>
      </div> */}
      {isLoading ? null : (
        <Content>
          <Block>
            <div className="invoice invoice-print">
              {/* <div className="invoice-action">
                <Button
                  size="lg"
                  color="primary"
                  outline
                  className="btn-icon btn-white btn-dim"
                  onClick={() => window.print()}
                >
                  <Icon name="printer-fill"></Icon>
                </Button>
              </div> */}
              <div className="invoice-wrap">
                <div className="invoice-brand text-center">
                  <img src={LogoDark} alt="" />
                </div>

                <div className="invoice-head">
                  <div className="invoice-contact">
                    <span className="overline-title">Invoice To</span>
                    <div className="invoice-contact-info">
                      <h4 className="title">{data?.order?.address?.name}</h4>
                      <ul className="list-plain">
                        <li>
                          <Icon name="map-pin-fill"></Icon>
                          <span>  
                            {data?.order?.address?.addressLine1}
                            <br />
                            {data?.order?.address?.city}, {data?.order?.address?.state}, {data?.order?.address?.country}{" "}
                            {data?.order?.address?.postal_code}
                          </span>
                        </li>
                        <li>
                          <Icon name="call-fill"></Icon>
                          <span>{data?.order?.address?.mobile}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="invoice-desc">
                    <h3 className="title">Invoice</h3>
                    <ul className="list-plain">
                      <li className="invoice-id">
                        <span>Invoice ID</span>:<span>{data?.order?.orderNum}</span>
                      </li>
                      <li className="invoice-date">
                        {/* <span>Date</span>:<span>{data?.order?.updatedAt?.split(",")[0]}</span> */}
                        <span>Date</span>:
                        <span>
                          {data?.order?.updatedAt
                            ? new Date(data.order.updatedAt).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                            : ""}
                        </span>
                      </li>
                      <li className="invoice-date">
                        <span>PHARMACY</span>:<span>{data?.order?.pharmacy?.store_name?.split(",")[0]}</span>
                      </li>
                      <li className="invoice-date">
                        <span>GST</span>:<span>{data?.order?.pharmacy?.gst_number?.split(",")[0]}</span>
                      </li>
                      <li className="invoice-date">
                        <span>Contact</span>:<span>{data?.order?.pharmacy?.mobile?.split(",")[0]}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="invoice-bills">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th className="w-150px">Item</th>
                          {/* <th className="w-60">Description</th> */}
                          <th></th>
                          <th>Price</th>
                          <th>Qty</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {console.log(data?.orderItems?.items, "ata?.orderItems?.items")}
                        {data?.orderItems?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.medicineName}</td>
                            <td></td>
                            {/* <td>Dashlite - Conceptual App Dashboard - Regular License</td> */}
                            <td>
                              {RUPEES_SYMBOL}
                              {item?.price}
                            </td>
                            <td>{item?.quantity}</td>
                            <td>
                              {RUPEES_SYMBOL}
                              {item?.price}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Subtotal</td>
                          <td>
                            {RUPEES_SYMBOL}
                            {data.order.totalAmount}
                          </td>
                        </tr>
                        {/* <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Shipping fee</td>
                          <td>{data?.shipping_cost}</td>
                        </tr> */}
                        {/* <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">GST</td>
                          <td>{data?.tax}</td>
                        </tr> */}
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Discount</td>
                          <td>{data?.order.discountAmount}</td>
                        </tr>
                        {/* <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Coupon</td>
                          <td>{data?.coupon_name || "N/A"}</td>
                        </tr> */}
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Grand Total</td>
                          <td>
                            {RUPEES_SYMBOL}
                            {data.order.totalAmount}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    <div className="nk-notes ff-italic fs-12px text-soft">
                      Invoice was created on a computer and is valid without the signature and seal.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Block>
        </Content>
      )}
    </body>
  );
};

export default InvoicePrint;
